class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.window = window;
    this.stickyATCBuyButtonMain = document.querySelector(".sticky-atc");
    this.buyButtonMain = document.querySelector(".buy-button-main");
    this.stickyATCButton = document.querySelector(".atc-sticky");
    this.mainATCButton = document.querySelector(".atc-main");

    if (this.stickyATCButton && this.mainATCButton) {
      this.stickyATCButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.mainATCButton.click();
      });
    }
  }

  connectedCallback() {
    this.window.addEventListener("scroll", () => {
      if (this.isInViewport()) {
        this.stickyATCBuyButtonMain.classList.remove("visible-sticky-atc");
      } else {
        this.stickyATCBuyButtonMain.classList.add("visible-sticky-atc");
      }
    });
  }

  disconnectedCallback() {}

  isInViewport() {
    const rect = this.buyButtonMain.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
  }
}

if (!window.customElements.get("sticky-atc")) {
  window.customElements.define("sticky-atc", StickyATC);
}

function handleCartUpsellSlider() {
  const slider = document.getElementById("cart-upsell-slider");
  if (!slider) return;

  if (window.slideshows && window.slideshows["cart-upsell-slider"]) {
    window.slideshows["cart-upsell-slider"].destroy();
  }

  if (slider.querySelector(".splide__list").children.length > 0) {
    window.slideshows["cart-upsell-slider"].mount();
  }
}

!customElements.get("product-tile") &&
  customElements.define(
    "product-tile",
    class ProductTile extends HTMLElement {
      constructor() {
        super();
        const form = this.querySelector(".quick-buy-product-form");
        form?.addEventListener("submit", this.submitHandler.bind(this));
      }
      submitHandler(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const formId = e.target.getAttribute("id");
        const config = fetchConfigDefaults("application/javascript");
        formData.append("sections", "cart-items,cart-footer,cart-item-count");
        formData.append("sections_url", window.location.pathname);
        config.body = formData;
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((res) => res.json())
          .then((data) => {
            if (data.status) {
              const errors = data.errors || data.description;
              const message = data.description || data.message;
              const errorDetail = {
                sourceId: formId,
                variantId: Number(formData.get("id")),
                errors,
                message,
              };
              document.body.dispatchEvent(
                new CustomEvent("shapes:cart:adderror", {
                  detail: {
                    source: "product-form",
                    ...errorDetail,
                  },
                })
              );
              document.dispatchEvent(
                new CustomEvent("theme:product:error:add-to-cart", {
                  detail: {
                    formEl: Alpine.raw(e.target),
                    ...errorDetail,
                  },
                })
              );
              return;
            }
            document.body.dispatchEvent(
              new CustomEvent("shapes:cart:afteradditem", {
                bubbles: true,
                detail: { response: data, sourceId: formId },
              })
            );
          })
          .catch((error) => {
            if (typeof error.json === "function") {
              error.json().then((a) => {
                alert(a.description);
              });
            } else {
              console.error(error);
            }
          })
          .finally(() => {
            handleCartUpsellSlider();
          });
      }
    }
  );

const isMac = () => {
  const platform =
    navigator.userAgentData?.platform || navigator.platform || "";
  return platform.toLowerCase().includes("mac");
};

if (isMac()) {
  document.body.classList.add("mac-os");
}

document.addEventListener("DOMContentLoaded", () => {
  const showMoreButtons = document.querySelectorAll(".product-complementary-products-more");
  const incrementCount = 2;

  if (showMoreButtons.length === 0) return;

  showMoreButtons.forEach((buttonContainer) => {
    let visibleCount = 2;

    const button = buttonContainer.querySelector("button");
    if (!button) return;

    button.addEventListener("click", () => {
      const productContainer = buttonContainer.closest(".product-complementary-products");
      const productTiles = productContainer.querySelectorAll("product-tile");
      const totalTiles = productTiles.length;

      productTiles.forEach((tile, index) => {
        if (index >= visibleCount && index < visibleCount + incrementCount) {
          tile.classList.remove("hidden");
        }
      });

      visibleCount += incrementCount;

      if (visibleCount >= totalTiles) {
        buttonContainer.remove();
      }
    });
  });
});

